import { useQuery } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'

export const MESSAGES_QUERY_KEY = (teamID: string) => ['messages', teamID]

export function useMessages(teamID: string) {
  return useQuery({
    queryKey: MESSAGES_QUERY_KEY(teamID),
    queryFn: () => dataSource.getMessages(teamID),
    enabled: !!teamID,
  })
}
